export default "__VITE_ASSET__69691025__"